/**
 * Berechnet die Spaltenbreiten (in %) der myCheck-Report-Ansicht (bic-result-column),
 * abhängig vom Prüfregeltyp und der Anzahl sichtbarer Spalten.
 */

export type RuleColumnKey = 'files' | 'structure' | 'rules' | 'detail';
export type IdsColumnKey = 'files' | 'specifications' | 'requirements';

/**
 * KI- und Hybrid-Prüfungen: Ergebnis-Spalte bekommt immer 50%, die übrigen
 * sichtbaren Spalten teilen sich die restlichen 50% gleichmäßig auf
 * (z. B. 3 Spalten -> 25/25/50, 4 Spalten -> 16,7/16,7/16,7/50).
 */
export function computeRuleColumnWidths(
  keys: RuleColumnKey[],
  emphasizeDetail: boolean,
): Partial<Record<RuleColumnKey, number>> {
  if (!emphasizeDetail || !keys.includes('detail')) return {};

  const otherKeys = keys.filter(key => key !== 'detail');
  const widths: Partial<Record<RuleColumnKey, number>> = {
    detail: otherKeys.length > 0 ? 50 : 100,
  };
  if (otherKeys.length > 0) {
    const otherWidth = 50 / otherKeys.length;
    for (const key of otherKeys) widths[key] = otherWidth;
  }
  return widths;
}

/**
 * IDS-Prüfungen: bei nur einer geprüften Datei entfällt die Dateien-Spalte
 * (50/50 zwischen Spezifikationen und Facetten), bei mehreren Dateien 20/40/40.
 */
export function computeIdsColumnWidths(
  keys: IdsColumnKey[],
): Partial<Record<IdsColumnKey, number>> {
  if (!keys.includes('specifications') || !keys.includes('requirements')) return {};

  const hasFiles = keys.includes('files');
  return hasFiles
    ? {files: 20, specifications: 40, requirements: 40}
    : {specifications: 50, requirements: 50};
}
